import { CTA, Title } from "@/ui";
import clsx from "classnames";
import { Col, Container, Row } from "react-bootstrap";
import classes from "./styles.module.scss";
import { bg } from "date-fns/locale";

export const RichText = ({ className, title, body, showCta, cta, bgColor, titleColor }) => {
  return (
    <div className={clsx(className, classes.text, `bg-${bgColor}`, `text-${titleColor}`)}>
      <Container className="mw-xxl">
        <Row>
          <Col xs={12}>
            {title && <Title title={title} />}
            {body && (
              <div className={clsx(classes.article__body)}>
                <div dangerouslySetInnerHTML={{ __html: body }} />
                {showCta && (
                  <CTA
                    className="mt-4"
                    label={cta.label}
                    href={cta.href}
                    variant={cta.variant}
                    data-sourceflow-prop="cta"
                  />
                )}
              </div>
            )}
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default RichText;
